<template>
  <div class="row mb-2">
    <div class="col-lg-3" style="max-width: 180px" v-if="isShowProfilePicture">
      <div
        v-if="
          jobFiller.profile_pic ==
            'https://d10217p7vdlmii.cloudfront.net/media/profile_pics/default_avatar.jpg' &&
          jobFiller.external_profile_pic
        "
      >
        <img
          :src="convertToAbsolutePath(jobFiller.external_profile_pic)"
          style="max-width: 150px"
        />
      </div>
      <div v-else>
        <img
          :src="convertToAbsolutePath(jobFiller.profile_pic)"
          style="max-width: 150px; border-radius: 3px"
        />
      </div>
    </div>
    <div
      :class="isShowProfilePicture ? 'col-lg-9' : 'col-lg-12'"
      style="width: 100%"
    >
      <h3 class="mt-2" style="margin-bottom: 0">
        {{ jobFiller.first_name }}
        <span v-if="!hideCandidateLastNameForShiftJobs">{{
          jobFiller.last_name
        }}</span>
        <i class="material-icons favorite-candidate" v-if="isFavorite">
          star
        </i>
      </h3>
      <div v-if="shiftViewFullProfile" class="mt-2">
        <button
          class="mylisting-button dark-button mt-1"
          @click="showUserProfileDialog(jobFiller.id, true)"
        >
          View Profile
        </button>
      </div>
      <DetailSectionRowLayout
        v-else
        :modelData="jobFillerInfo"
        labelKey="displayLabel"
        :listFields="listVisibleFields"
        :hideDescription="true"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { PROFILE_PICTURE_SCOPE } from "../../constants/custom-define-type";

export default {
  name: "JobFillerInfo",
  props: {
    jobFiller: Object,
    listFields: Array,
    listAdditionalInfo: {
      type: Array,
      default: () => [],
    },
    isFavorite: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "hideCandidateLastNameForShiftJobs",
      "shiftViewFullProfile",
    ]),
    listVisibleFields() {
      if (!this.listFields) {
        return [];
      }
      return this.listFields.filter(
        (field) => !["user_badges__agency_badge_id", "reviews"].includes(field.model)
      );
    },
    jobFillerInfo() {
      const result = this.jobFiller;
      if (this.listAdditionalInfo && this.jobFiller.id) {
        const filler = this.listAdditionalInfo.find(
          (user) => user.id === this.jobFiller.id
        );
        if (filler) {
          return { ...result, ...filler };
        }
      }
      return result;
    },
    isShowProfilePicture() {
      if (this.$store.getters.agencyPublic == null) {
        return false;
      }
      let scope =
        this.$store.getters.agencyPublic.candidate_profile_picture_scope;
      // In case of candidate, default is public
      if (scope === "") {
        scope = PROFILE_PICTURE_SCOPE.PUBLIC;
      }
      if (scope == null) {
        return false;
      }

      if (scope === PROFILE_PICTURE_SCOPE.PUBLIC) {
        // Public: always show
        return true;
      }
      // No profile picture
      return false;
    },
  },
};
</script>

<style scoped>
.favorite-candidate {
  color: gold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/JobFillerInfo.vue